import React, { useState } from "react";
import axios from "axios";
import axiosClient from "../../axios-client";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [modalMessage, setModalMessage] = useState(null); // Message for the modal
  const [modalType, setModalType] = useState(""); // 'success' or 'error'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (currentPassword === newPassword) {
      setError("New password cannot be the same as the current password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setModalMessage("New password and confirm password do not match.");
      setModalType("error");
      return;
    }

    // Enforce 8-16 characters, at least one letter, and one number
    const isValidPassword = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(newPassword);
    if (!isValidPassword) {
      setModalMessage("New password must be 8-16 characters long and contain both letters and numbers.");
      setModalType("error");
      return;
    }

    setLoading(true);

    const token = localStorage.getItem("token");

    if (!token) {
      setModalMessage("No token found. Please log in again.");
      setModalType("error");
      setLoading(false);
      
      return;
    }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axiosClient.post(
        "users/profile/updateUserPassword",
        { currentPassword, newPassword },
        config
      );

      setModalMessage(
        response.data.message || "Password updated successfully."
      );
      setModalType("success");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred. Please try again.";
      setModalMessage(errorMsg);
      setModalType("error");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setModalMessage(null);
    setModalType("");
  };

  return (
    <div className="border5 p-4">
      <h2 className="text-xl font-semibold">Change Password</h2>
      <p className="font4">Update your account password here.</p>
      <h5 className="text-red-500">{error}</h5>
      <form className="space-y-4 mt-4" onSubmit={handleChangePassword}>
        <div>
          <label className="block text-sm font-medium">Current Password*</label>
          <input
            type="password"
            className="mt-2 p-2 block w-full sm:w-[80%] lg:w-[50%] border border-black rounded-lg shadow-sm"
            placeholder="Enter current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium">New Password*</label>
          <input
            type="password"
            className="mt-2 p-2 block w-full sm:w-[80%] lg:w-[50%] border border-black rounded-lg shadow-sm"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium">
            Confirm New Password*
          </label>
          <input
            type="password"
            className="mt-2 mb-6 p-2 block w-full sm:w-[80%] lg:w-[50%] border border-black rounded-lg shadow-sm"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`w-full sm:w-auto px-10 hover:bg-black text-white p-2 rounded-md bg-login font-medium ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>

      {/* Modal */}
      {modalMessage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeModal}
        >
          <div
            className={`bg-white p-6 rounded-lg text-center shadow-lg ${
              modalType === "success" ? "text-green-500" : "text-red-500"
            }`}
          >
            <p className="mb-4">{modalMessage}</p>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
              onClick={closeModal}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChangePassword;
